const CHECK_NEW_ORDERS_QUEUED = "CHECK_NEW_ORDERS_QUEUED";
const CHECK_NEW_ORDERS_QUEUED_SUCCESS = "CHECK_NEW_ORDERS_QUEUED_SUCCESS";
const CHECK_NEW_ORDERS_QUEUED_FAILURE = "CHECK_NEW_ORDERS_QUEUED_FAILURE";
const CLEAR_CHECK_NEW_ORDERS_QUEUED = "CLEAR_CHECK_NEW_ORDERS_QUEUED";
const checkNewOrdersQueuedSymbols = {
  CHECK_NEW_ORDERS_QUEUED_SUCCESS,
  CHECK_NEW_ORDERS_QUEUED_FAILURE,
  CHECK_NEW_ORDERS_QUEUED,
  CLEAR_CHECK_NEW_ORDERS_QUEUED,
};
export default checkNewOrdersQueuedSymbols;
